var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-control-skype" },
    [
      _c("ui-clipboard-input", {
        attrs: { hint: "Link copied to clipboard", label: "Recorder URI" },
        model: {
          value: _vm.recorderUri,
          callback: function ($$v) {
            _vm.recorderUri = $$v
          },
          expression: "recorderUri",
        },
      }),
      _vm._v(" "),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-caption" }, [
      _c("p", [
        _vm._v(
          "You can record (and optionally stream) a Skype for Business (SfB) meeting by adding the above Recorder URI to the meeting as a participant."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "The recording (and live streaming if enabled) will start as soon as the participant has been added to the meeting. You can also do a personal recording or live streaming by calling from SfB directly to the above address (without adding it to a meeting)."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We recommend that you add the above address as a Contact in SfB for easy of use."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Please note that your SfB account needs to be enabled with External Communication in general, or specifically for the domain of the above address."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }